import { render, staticRenderFns } from "./ATablaMatricula.vue?vue&type=template&id=1102aa66"
import script from "./ATablaMatricula.vue?vue&type=script&lang=js"
export * from "./ATablaMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports